import React, { useEffect, useState } from "react";
import { Table } from "react-bootstrap";
import PageHeader from "./ui/PageHeader";
import DataCard from "./ui/DataCard";
import LoadingState from "./ui/LoadingState";
import AlertBanner from "./ui/AlertBanner";

const API = process.env.REACT_APP_API_BASE || "http://localhost/webservices/dashboard";

const AuditLogs = () => {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetch(`${API}/audit/list.php`)
      .then((r) => r.json())
      .then((p) => { if (!p.status) throw new Error(p.message); setLogs(p.data); })
      .catch((err) => setError(err.message))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <LoadingState message="Loading audit logs..." />;
  if (error) return <AlertBanner type="danger" message={error} />;

  return (
    <div>
      <PageHeader title="Audit Logs" subtitle="System activity and admin action history" />
      <DataCard title={`Recent Events (${logs.length})`}>
        <Table responsive className="billr-table mb-0">
          <thead><tr><th>Type</th><th>Detail</th><th>Timestamp</th><th>IP</th></tr></thead>
          <tbody>
            {logs.map((log, idx) => (
              <tr key={idx}>
                <td><span className="billr-badge secondary">{log.type}</span></td>
                <td>{log.detail}</td>
                <td className="text-muted">{log.timestamp}</td>
                <td><code className="small">{log.ip}</code></td>
              </tr>
            ))}
          </tbody>
        </Table>
      </DataCard>
    </div>
  );
};

export default AuditLogs;
